export const ArrowRight = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M18 6L16.57 7.393L24.15 15H4V17H24.15L16.57 24.573L18 26L28 16L18 6Z" fill="currentColor"/>
<path d="M18.29 6.58913L27.5876 15.9993L18.3235 25.3187" stroke="currentColor" stroke-width="2"/>
<path d="M4.99866 16.0047L26.9987 16.0047" stroke="currentColor" stroke-width="2"/>
</svg>`;
